import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button, MenuSection, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchCollectionById } from "../../api/collectionsService";
import CollectionDetail from "./CollectionDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { formatCollectionName } from "../../utils/collectionDisplayUtils";
import { usePermissions } from "../../hooks/usePermissions";
import { RoleGroups } from "../../types/RoleEnum";
var CollectionsDetailPage = function () {
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var hasAnyRole = usePermissions().hasAnyRole;
    var canEditCollection = hasAnyRole(RoleGroups.COLLECTION_EDITOR_ROLES);
    var _a = useQuery(["collection", id], function () { return fetchCollectionById(ky, id); }, {
        enabled: !!id,
    }), collection = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    var handleBackToList = function () {
        history.goBack();
    };
    var handleEdit = function () {
        history.push("/bragency/collections/edit/".concat(id));
    };
    if (!id) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.collections.detail.pane.title",
                }) },
                React.createElement("p", null, formatMessage({ id: "ui-br-agency.collections.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.collections.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (isError || !collection) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.collections.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) ||
                    formatMessage({ id: "ui-br-agency.collections.not.found" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    var displayName = formatCollectionName(collection) ||
        formatMessage({ id: "ui-br-agency.collections.detail.pane.title" });
    var actionMenu = canEditCollection
        ? function (_a) {
            var onToggle = _a.onToggle;
            return (React.createElement(MenuSection, { id: "collection-actions" },
                React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        onToggle();
                        handleEdit();
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" }))));
        }
        : undefined;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: displayName, firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })), actionMenu: actionMenu },
            React.createElement(CollectionDetail, { collection: collection }))));
};
export default CollectionsDetailPage;
